// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import Navbar from '../components/Layout/Navbar';
// import { isAuthenticated } from '../utils/auth';
// import api from '../services/api';
// import './Feedback.css';

// interface FeedbackAppointment {
//   id: number;
//   patient_name: string;
//   pet_name: string;
//   appointment_type: string;
//   date: string;
//   time: string;
//   status: string;
//   appointment_status: string;
//   feedback_call_initiated: string | null;
//   feedback_call_picked: string | null;
//   feedback_given: string | null;
//   feedback_recording_url: string | null;
//   phone?: string;
// }

// const Feedback: React.FC = () => {
//   const navigate = useNavigate();
//   const [activeTab, setActiveTab] = useState('Feed Back');
//   const [appointments, setAppointments] = useState<FeedbackAppointment[]>([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');
//   const [showModal, setShowModal] = useState(false);
//   const [selectedAppointment, setSelectedAppointment] = useState<FeedbackAppointment | null>(null);
//   const [calling, setCalling] = useState(false);

//   useEffect(() => {
//     if (!isAuthenticated()) {
//       navigate('/login');
//       return;
//     }
//     fetchFeedbackAppointments();
//   }, [navigate]);

//   const fetchFeedbackAppointments = async () => {
//     try {
//       setLoading(true);
//       // Fetch all appointments (completed) with feedback data
//       // Adjust endpoint as needed – assuming there is an admin endpoint to get appointments with feedback fields
//       const response = await api.get('/admin/all?page=1&limit=100');
//       if (response.data.success) {
//         setAppointments(response.data.data.appointments || []);
//       } else {
//         setError(response.data.message || 'Failed to load feedback data');
//       }
//     } catch (err: any) {
//       console.error('Error fetching feedback appointments:', err);
//       setError(err.response?.data?.message || 'Failed to load feedback data');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleTabChange = (tab: string) => {
//     setActiveTab(tab);
//     navigate(`/${tab.toLowerCase().replace(' ', '')}`);
//   };

//   const formatDate = (dateString: string) => {
//     const date = new Date(dateString);
//     return date.toLocaleDateString();
//   };

//   const formatTime = (timeString: string) => {
//     if (!timeString) return 'N/A';
//     return timeString;
//   };

//   const getFeedbackStatusBadge = (appointment: FeedbackAppointment) => {
//     if (appointment.feedback_call_initiated === 'true') {
//       if (appointment.feedback_call_picked === 'true') {
//         return <span className="badge success">✅ Feedback Collected</span>;
//       } else {
//         return <span className="badge warning">📞 Call Not Picked</span>;
//       }
//     }
//     return <span className="badge pending">⏳ Pending</span>;
//   };

//   const openFeedbackModal = (appointment: FeedbackAppointment) => {
//     setSelectedAppointment(appointment);
//     setShowModal(true);
//   };

//   const closeModal = () => {
//     setShowModal(false);
//     setSelectedAppointment(null);
//   };

//   const initiateFeedbackCall = async () => {
//     if (!selectedAppointment) return;
//     setCalling(true);
//     try {
//       // Call your initiateFeedbackCallDirect API
//       const response = await api.post('/appointments/feedback-call', {
//         phoneNumber: selectedAppointment.phone,
//         patientName: selectedAppointment.patient_name,
//         petName: selectedAppointment.pet_name,
//         appointmentType: selectedAppointment.appointment_type,
//         appointmentDate: selectedAppointment.date,
//         appointmentTime: selectedAppointment.time,
//         appointmentId: String(selectedAppointment.id)
//       });
//       if (response.data.success) {
//         alert('Outbound feedback call initiated successfully');
//         // Optionally refresh data
//         fetchFeedbackAppointments();
//         closeModal();
//       } else {
//         alert(response.data.message || 'Failed to initiate call');
//       }
//     } catch (err: any) {
//       alert(err.response?.data?.message || 'Error initiating call');
//     } finally {
//       setCalling(false);
//     }
//   };

//   if (!isAuthenticated()) return null;

//   if (loading) {
//     return (
//       <div className="feedback-page">
//         <Navbar activeTab={activeTab} onTabChange={handleTabChange} />
//         <div className="page-content">
//           <div className="loading-container">Loading feedback data...</div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="feedback-page">
//       <Navbar activeTab={activeTab} onTabChange={handleTabChange} />
//       <div className="page-content">
//         <h1>📋 Patient Feedback</h1>
//         {error && <div className="error-message">{error}</div>}
        
//         {appointments.length === 0 ? (
//           <div className="no-data">No completed appointments with feedback data found.</div>
//         ) : (
//           <div className="feedback-table-container">
//             <table className="feedback-table">
//               <thead>
//                 <tr>
//                   <th>ID</th>
//                   <th>Patient</th>
//                   <th>Pet</th>
//                   <th>Appointment Type</th>
//                   <th>Date</th>
//                   <th>Time</th>
//                   <th>Feedback Status</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {appointments.map((apt) => (
//                   <tr key={apt.id}>
//                     <td>{apt.id}</td>
//                     <td>{apt.patient_name}</td>
//                     <td>{apt.pet_name}</td>
//                     <td>{apt.appointment_type}</td>
//                     <td>{formatDate(apt.date)}</td>
//                     <td>{formatTime(apt.time)}</td>
//                     <td>{getFeedbackStatusBadge(apt)}</td>
//                     <td>
//                       <button className="view-btn" onClick={() => openFeedbackModal(apt)}>
//                         View Details
//                       </button>
//                       {apt.feedback_call_initiated !== 'true' && (
//                         <button className="call-btn" onClick={() => openFeedbackModal(apt)}>
//                           📞 Initiate Call
//                         </button>
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}
//       </div>

//       {/* Modal for feedback details */}
//       {showModal && selectedAppointment && (
//         <div className="modal-overlay" onClick={closeModal}>
//           <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Feedback Details</h3>
//               <button className="close-modal" onClick={closeModal}>✕</button>
//             </div>
//             <div className="modal-body">
//               <div className="detail-row">
//                 <span className="label">Appointment ID:</span>
//                 <span>{selectedAppointment.id}</span>
//               </div>
//               <div className="detail-row">
//                 <span className="label">Patient:</span>
//                 <span>{selectedAppointment.patient_name}</span>
//               </div>
//               <div className="detail-row">
//                 <span className="label">Pet:</span>
//                 <span>{selectedAppointment.pet_name}</span>
//               </div>
//               <div className="detail-row">
//                 <span className="label">Date & Time:</span>
//                 <span>{formatDate(selectedAppointment.date)} {selectedAppointment.time}</span>
//               </div>
//               <div className="detail-row">
//                 <span className="label">Call Initiated:</span>
//                 <span>{selectedAppointment.feedback_call_initiated === 'true' ? 'Yes' : 'No'}</span>
//               </div>
//               <div className="detail-row">
//                 <span className="label">Call Picked:</span>
//                 <span>{selectedAppointment.feedback_call_picked === 'true' ? 'Yes' : 'No'}</span>
//               </div>
//               <div className="detail-row feedback-text">
//                 <span className="label">Feedback Given:</span>
//                 <p>{selectedAppointment.feedback_given || 'No feedback recorded yet.'}</p>
//               </div>
//               {selectedAppointment.feedback_recording_url && (
//                 <div className="detail-row">
//                   <span className="label">Recording:</span>
//                   <a href={selectedAppointment.feedback_recording_url} target="_blank" rel="noopener noreferrer">
//                     🎧 Listen
//                   </a>
//                 </div>
//               )}
//               {selectedAppointment.feedback_call_initiated !== 'true' && (
//                 <div className="call-action">
//                   <button onClick={initiateFeedbackCall} disabled={calling}>
//                     {calling ? 'Initiating...' : '📞 Initiate Feedback Call'}
//                   </button>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Feedback;






import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Layout/Navbar';
import { isAuthenticated } from '../utils/auth';
import api from '../services/api';
import './Feedback.css';

interface FeedbackAppointment {
  id: number;
  patient_name: string;
  pet_name: string;
  appointment_type: string;
  date: string;
  time: string;
  status: string;
  appointment_status: string;
  feedback_call_initiated: string | null;
  feedback_call_picked: string | null;
  feedback_given: string | null;
  feedback_recording_url: string | null;
  feedback_call_attempted?: boolean;      // added
  phone?: string;
}

const Feedback: React.FC = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('Feedback');  // changed from 'Feed Back'
  const [appointments, setAppointments] = useState<FeedbackAppointment[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState<FeedbackAppointment | null>(null);
  const [calling, setCalling] = useState(false);

  useEffect(() => {
    if (!isAuthenticated()) {
      navigate('/login');
      return;
    }
    fetchFeedbackAppointments();
  }, [navigate]);

  const fetchFeedbackAppointments = async () => {
    try {
      setLoading(true);
      // Use existing admin endpoint that returns all appointments (including feedback fields)
      const response = await api.get('/admin/all?page=1&limit=100');
      if (response.data.success) {
        setAppointments(response.data.data.appointments || []);
      } else {
        setError(response.data.message || 'Failed to load feedback data');
      }
    } catch (err: any) {
      console.error('Error fetching feedback appointments:', err);
      setError(err.response?.data?.message || 'Failed to load feedback data');
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    navigate(`/${tab.toLowerCase()}`);
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  const formatTime = (timeString: string) => {
    if (!timeString) return 'N/A';
    return timeString;
  };

  const getFeedbackStatusBadge = (appointment: FeedbackAppointment) => {
    if (appointment.feedback_call_initiated === 'true') {
      if (appointment.feedback_call_picked === 'true') {
        return <span className="badge success">✅ Collected</span>;
      } else {
        return <span className="badge warning">📞 Not Picked</span>;
      }
    }
    return <span className="badge pending">⏳ Pending</span>;
  };

  const openFeedbackModal = (appointment: FeedbackAppointment) => {
    setSelectedAppointment(appointment);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedAppointment(null);
  };

  const initiateFeedbackCall = async () => {
    if (!selectedAppointment) return;
    setCalling(true);
    try {
      const response = await api.post('/appointments/feedback-call', {
        phoneNumber: selectedAppointment.phone,
        patientName: selectedAppointment.patient_name,
        petName: selectedAppointment.pet_name,
        appointmentType: selectedAppointment.appointment_type,
        appointmentDate: selectedAppointment.date,
        appointmentTime: selectedAppointment.time,
        appointmentId: String(selectedAppointment.id)
      });
      if (response.data.success) {
        alert('Outbound feedback call initiated successfully');
        fetchFeedbackAppointments();  // refresh data
        closeModal();
      } else {
        alert(response.data.message || 'Failed to initiate call');
      }
    } catch (err: any) {
      alert(err.response?.data?.message || 'Error initiating call');
    } finally {
      setCalling(false);
    }
  };

  if (!isAuthenticated()) return null;

  if (loading) {
    return (
      <div className="feedback-page">
        <Navbar activeTab={activeTab} onTabChange={handleTabChange} />
        <div className="page-content">
          <div className="loading-container">Loading feedback data...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="feedback-page">
      <Navbar activeTab={activeTab} onTabChange={handleTabChange} />
      <div className="page-content">
        <h1>📋 Patient Feedback</h1>
        {error && <div className="error-message">{error}</div>}
        
        {appointments.length === 0 ? (
          <div className="no-data">No completed appointments with feedback data found.</div>
        ) : (
          <div className="feedback-table-container">
            <table className="feedback-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Patient</th>
                  <th>Pet</th>
                  <th>Appointment Type</th>
                  <th>Date</th>
                  <th>Time</th>
                  <th>Feedback Status</th>
                  <th>Feedback Given</th>
                  <th>Feedback Call Attempted</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {appointments.map((apt) => (
                  <tr key={apt.id}>
                    <td>{apt.id}</td>
                    <td>{apt.patient_name}</td>
                    <td>{apt.pet_name}</td>
                    <td>{apt.appointment_type}</td>
                    <td>{formatDate(apt.date)}</td>
                    <td>{apt.time}</td>
                    <td>{getFeedbackStatusBadge(apt)}</td>
                    <td className="feedback-text-cell">{apt.feedback_given || '—'}</td>
                    <td>
                      {apt.feedback_call_attempted ? (
                        <span className="badge success">✅ Yes</span>
                      ) : (
                        <span className="badge pending">❌ No</span>
                      )}
                    </td>
                    <td>
                      <button className="view-btn" onClick={() => openFeedbackModal(apt)}>
                        View Details
                      </button>
                      {!apt.feedback_call_attempted && (
                        <button className="call-btn" onClick={() => openFeedbackModal(apt)}>
                          📞 Initiate Call
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Modal for feedback details */}
      {showModal && selectedAppointment && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Feedback Details</h3>
              <button className="close-modal" onClick={closeModal}>✕</button>
            </div>
            <div className="modal-body">
              <div className="detail-row">
                <span className="label">Appointment ID:</span>
                <span>{selectedAppointment.id}</span>
              </div>
              <div className="detail-row">
                <span className="label">Patient:</span>
                <span>{selectedAppointment.patient_name}</span>
              </div>
              <div className="detail-row">
                <span className="label">Pet:</span>
                <span>{selectedAppointment.pet_name}</span>
              </div>
              <div className="detail-row">
                <span className="label">Date & Time:</span>
                <span>{formatDate(selectedAppointment.date)} {selectedAppointment.time}</span>
              </div>
              <div className="detail-row">
                <span className="label">Call Initiated:</span>
                <span>{selectedAppointment.feedback_call_initiated === 'true' ? 'Yes' : 'No'}</span>
              </div>
              <div className="detail-row">
                <span className="label">Call Picked:</span>
                <span>{selectedAppointment.feedback_call_picked === 'true' ? 'Yes' : 'No'}</span>
              </div>
              <div className="detail-row feedback-text">
                <span className="label">Feedback Given:</span>
                <p>{selectedAppointment.feedback_given || 'No feedback recorded yet.'}</p>
              </div>
              {selectedAppointment.feedback_recording_url && (
                <div className="detail-row">
                  <span className="label">Recording:</span>
                  <a href={selectedAppointment.feedback_recording_url} target="_blank" rel="noopener noreferrer">
                    🎧 Listen
                  </a>
                </div>
              )}
              {!selectedAppointment.feedback_call_attempted && (
                <div className="call-action">
                  <button onClick={initiateFeedbackCall} disabled={calling}>
                    {calling ? 'Initiating...' : '📞 Initiate Feedback Call'}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Feedback;